import { useState, useEffect } from "react";

import { useProjects } from "~/pages/projects/contexts/projects-context";
import { IProject } from "~/integrations/firebase/collections";
import { useProducts } from "./use-products";

export const useProject = (idProject?: string) => {
  const projectsHook = useProjects();
  const { getProject } = projectsHook;
  const [errorProjectRead, setErrorProjectRead] = useState<string>();

  const [project, setProject] = useState<IProject | null>(null);

  useEffect(() => {
    const loadProject = async () => {
      if (!idProject) {
        setErrorProjectRead(undefined);
        setProject(null);
        return;
      }
      try {
        setErrorProjectRead(undefined);
        const loadedProject = await getProject(idProject);
        setProject(loadedProject || null);
      } catch {
        setErrorProjectRead("Cannot load project");
      }
    };
    loadProject();
  }, [getProject, idProject]);

  const {
    products,
    isLoadingRead: isLoadingProducts,
    errorRead: errorProductsRead,
  } = useProducts(project?.productIds);

  return {
    project,
    products,
    isLoadingProducts,
    errorProductsRead,
    errorProjectRead,
    ...projectsHook,
  };
};
